import React from 'react';

import 'react-edit-text/dist/index.css';

import { EditText } from 'react-edit-text';
import 'react-edit-text/dist/index.css';
import {EditableInputContainer} from "./styles";

interface InputEditableProps {
    id: string;
    value: string;
    onChange: Function;
    name: string;
    onSave: Function;
    placeholder?: string;
}
export function InputEditable({id, value, onChange, name, onSave, placeholder} : InputEditableProps) {
    return (
        <div>
            <EditableInputContainer>
                <EditText name={name} value={value} id={id} onChange={(e) => onChange(e)} onSave={() => onSave()} placeholder={placeholder} showEditButton/>
            </EditableInputContainer>
        </div>

    );
}
